// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/vote/2023superpowers/MOBILE/Meteor Viedo_M_4.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./font/GenSenRoundedTW-M.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./font/GenYoGothic-B.ttc", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./font/GenYoGothic-H.ttc", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./font/GenYoGothic-M.ttc", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./font/DelaGothicOne.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./font/LINESeedJP_TTF_Bd.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./font/LINESeedJP_TTF_Eb.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./font/LINESeedJP_TTF_Rg.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./font/LINESeedJP_TTF_Th.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("assets/vote/2023superpowers/DESKTOP/Meteor Viedo_D_4.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1300px) {

  .container {
    max-width: 1300px;
  }
}
@media (min-width: 1440px) {

  .container {
    max-width: 1440px;
  }
}
@media (min-width: 1536px) {

  .container {
    max-width: 1536px;
  }
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  inset: 0px;
}
.-bottom-\\[20px\\] {
  bottom: -20px;
}
.-bottom-\\[3\\.52\\%\\] {
  bottom: -3.52%;
}
.-left-\\[13\\.38\\%\\] {
  left: -13.38%;
}
.-left-\\[32px\\] {
  left: -32px;
}
.-right-\\[11\\%\\] {
  right: -11%;
}
.-right-\\[24px\\] {
  right: -24px;
}
.-right-\\[30px\\] {
  right: -30px;
}
.-right-\\[31px\\] {
  right: -31px;
}
.-top-\\[21px\\] {
  top: -21px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-47px {
  bottom: 47px;
}
.bottom-50px {
  bottom: 50px;
}
.bottom-8px {
  bottom: 8px;
}
.bottom-\\[-1px\\] {
  bottom: -1px;
}
.bottom-\\[-2\\.5\\%\\] {
  bottom: -2.5%;
}
.bottom-\\[0\\] {
  bottom: 0;
}
.bottom-\\[1\\.5\\%\\] {
  bottom: 1.5%;
}
.bottom-\\[23\\%\\] {
  bottom: 23%;
}
.bottom-\\[24\\.3\\%\\] {
  bottom: 24.3%;
}
.bottom-\\[24px\\] {
  bottom: 24px;
}
.bottom-\\[4px\\] {
  bottom: 4px;
}
.bottom-\\[50\\%\\] {
  bottom: 50%;
}
.bottom-\\[7\\.27\\%\\] {
  bottom: 7.27%;
}
.left-0 {
  left: 0px;
}
.left-1\\/2 {
  left: 50%;
}
.left-10px {
  left: 10px;
}
.left-12px {
  left: 12px;
}
.left-4px {
  left: 4px;
}
.left-N10px {
  left: -10px;
}
.left-N6px {
  left: -6px;
}
.left-\\[-10px\\] {
  left: -10px;
}
.left-\\[-18px\\] {
  left: -18px;
}
.left-\\[0\\] {
  left: 0;
}
.left-\\[10px\\] {
  left: 10px;
}
.left-\\[11\\.5\\%\\] {
  left: 11.5%;
}
.left-\\[13\\%\\] {
  left: 13%;
}
.left-\\[41\\%\\] {
  left: 41%;
}
.left-\\[50\\%\\] {
  left: 50%;
}
.right-0 {
  right: 0px;
}
.right-12px {
  right: 12px;
}
.right-25px {
  right: 25px;
}
.right-\\[-18px\\] {
  right: -18px;
}
.right-\\[0\\] {
  right: 0;
}
.right-\\[11\\.5\\%\\] {
  right: 11.5%;
}
.right-\\[11px\\] {
  right: 11px;
}
.right-\\[14px\\] {
  right: 14px;
}
.right-\\[16px\\] {
  right: 16px;
}
.right-\\[18\\%\\] {
  right: 18%;
}
.right-\\[18px\\] {
  right: 18px;
}
.right-\\[4\\%\\] {
  right: 4%;
}
.right-\\[6px\\] {
  right: 6px;
}
.right-\\[8px\\] {
  right: 8px;
}
.top-0 {
  top: 0px;
}
.top-7px {
  top: 7px;
}
.top-N15px {
  top: -15px;
}
.top-N18px {
  top: -18px;
}
.top-N80px {
  top: -80px;
}
.top-\\[-11px\\] {
  top: -11px;
}
.top-\\[-18vw\\] {
  top: -18vw;
}
.top-\\[-7\\%\\] {
  top: -7%;
}
.top-\\[0\\] {
  top: 0;
}
.top-\\[10\\%\\] {
  top: 10%;
}
.top-\\[103px\\] {
  top: 103px;
}
.top-\\[15px\\] {
  top: 15px;
}
.top-\\[168px\\] {
  top: 168px;
}
.top-\\[16px\\] {
  top: 16px;
}
.top-\\[30\\%\\] {
  top: 30%;
}
.top-\\[33\\.8\\%\\] {
  top: 33.8%;
}
.top-\\[35\\%\\] {
  top: 35%;
}
.top-\\[4\\%\\] {
  top: 4%;
}
.top-\\[45\\%\\] {
  top: 45%;
}
.top-\\[50\\%\\] {
  top: 50%;
}
.top-\\[6\\%\\] {
  top: 6%;
}
.top-\\[6\\.5\\%\\] {
  top: 6.5%;
}
.top-\\[60px\\] {
  top: 60px;
}
.top-\\[65\\%\\] {
  top: 65%;
}
.top-\\[65px\\] {
  top: 65px;
}
.top-\\[6px\\] {
  top: 6px;
}
.top-\\[8\\%\\] {
  top: 8%;
}
.top-\\[8px\\] {
  top: 8px;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-30 {
  z-index: 30;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.float-right {
  float: right;
}
.m-4 {
  margin: 1rem;
}
.m-auto {
  margin: auto;
}
.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}
.mx-10px {
  margin-left: 0.625rem;
  margin-right: 0.625rem;
}
.mx-12px {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}
.mx-\\[18px\\] {
  margin-left: 18px;
  margin-right: 18px;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.-mb-\\[3px\\] {
  margin-bottom: -3px;
}
.-ml-\\[17\\%\\] {
  margin-left: -17%;
}
.-ml-\\[3px\\] {
  margin-left: -3px;
}
.-ml-\\[6px\\] {
  margin-left: -6px;
}
.-mr-\\[3px\\] {
  margin-right: -3px;
}
.-mr-\\[6px\\] {
  margin-right: -6px;
}
.-mt-\\[8px\\] {
  margin-top: -8px;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-13px {
  margin-bottom: 0.8125rem;
}
.mb-15px {
  margin-bottom: 0.9375rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-20px {
  margin-bottom: 1.25rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-50px {
  margin-bottom: 3.125rem;
}
.mb-\\[0px\\] {
  margin-bottom: 0px;
}
.mb-\\[10px\\] {
  margin-bottom: 10px;
}
.mb-\\[13px\\] {
  margin-bottom: 13px;
}
.mb-\\[16px\\] {
  margin-bottom: 16px;
}
.mb-\\[20px\\] {
  margin-bottom: 20px;
}
.mb-\\[24px\\] {
  margin-bottom: 24px;
}
.mb-\\[27px\\] {
  margin-bottom: 27px;
}
.mb-\\[35px\\] {
  margin-bottom: 35px;
}
.mb-\\[36px\\] {
  margin-bottom: 36px;
}
.mb-\\[40px\\] {
  margin-bottom: 40px;
}
.mb-\\[48px\\] {
  margin-bottom: 48px;
}
.mb-\\[4px\\] {
  margin-bottom: 4px;
}
.mb-\\[8px\\] {
  margin-bottom: 8px;
}
.ml-0 {
  margin-left: 0px;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-\\[17px\\] {
  margin-left: 17px;
}
.ml-\\[18px\\] {
  margin-left: 18px;
}
.ml-\\[36px\\] {
  margin-left: 36px;
}
.ml-\\[4px\\] {
  margin-left: 4px;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-12px {
  margin-right: 0.75rem;
}
.mr-15px {
  margin-right: 0.9375rem;
}
.mr-\\[1\\/2em\\] {
  margin-right: 1/2em;
}
.mr-\\[10\\%\\] {
  margin-right: 10%;
}
.mr-\\[10px\\] {
  margin-right: 10px;
}
.mr-\\[15px\\] {
  margin-right: 15px;
}
.mr-\\[16px\\] {
  margin-right: 16px;
}
.mr-\\[20px\\] {
  margin-right: 20px;
}
.mr-\\[4px\\] {
  margin-right: 4px;
}
.mr-\\[8px\\] {
  margin-right: 8px;
}
.mt-0 {
  margin-top: 0px;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-20px {
  margin-top: 1.25rem;
}
.mt-24px {
  margin-top: 1.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-49px {
  margin-top: 2.75rem;
}
.mt-50px {
  margin-top: 3.125rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[-24px\\] {
  margin-top: -24px;
}
.mt-\\[-2px\\] {
  margin-top: -2px;
}
.mt-\\[10px\\] {
  margin-top: 10px;
}
.mt-\\[16px\\] {
  margin-top: 16px;
}
.mt-\\[24px\\] {
  margin-top: 24px;
}
.mt-\\[26px\\] {
  margin-top: 26px;
}
.mt-\\[4px\\] {
  margin-top: 4px;
}
.mt-\\[5px\\] {
  margin-top: 5px;
}
.mt-\\[6vh\\] {
  margin-top: 6vh;
}
.mt-\\[8px\\] {
  margin-top: 8px;
}
.mt-\\[9px\\] {
  margin-top: 9px;
}
.mt-m10px {
  margin-top: -0.625rem;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-square {
  aspect-ratio: 1 / 1;
}
.h-0 {
  height: 0px;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-128px {
  height: 8rem;
}
.h-154px {
  height: 9.625rem;
}
.h-4 {
  height: 1rem;
}
.h-6 {
  height: 1.5rem;
}
.h-600px {
  height: 37.5rem;
}
.h-8 {
  height: 2rem;
}
.h-\\[1\\.5px\\] {
  height: 1.5px;
}
.h-\\[10px\\] {
  height: 10px;
}
.h-\\[10vw\\] {
  height: 10vw;
}
.h-\\[142px\\] {
  height: 142px;
}
.h-\\[14px\\] {
  height: 14px;
}
.h-\\[17px\\] {
  height: 17px;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[213px\\] {
  height: 213px;
}
.h-\\[21px\\] {
  height: 21px;
}
.h-\\[22px\\] {
  height: 22px;
}
.h-\\[24px\\] {
  height: 24px;
}
.h-\\[28px\\] {
  height: 28px;
}
.h-\\[29px\\] {
  height: 29px;
}
.h-\\[2px\\] {
  height: 2px;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[32px\\] {
  height: 32px;
}
.h-\\[33\\.33px\\] {
  height: 33.33px;
}
.h-\\[37px\\] {
  height: 37px;
}
.h-\\[384\\.048px\\] {
  height: 384.048px;
}
.h-\\[40px\\] {
  height: 40px;
}
.h-\\[44px\\] {
  height: 44px;
}
.h-\\[455\\.168px\\] {
  height: 455.168px;
}
.h-\\[48px\\] {
  height: 48px;
}
.h-\\[4px\\] {
  height: 4px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[63\\%\\] {
  height: 63%;
}
.h-\\[64px\\] {
  height: 64px;
}
.h-\\[78px\\] {
  height: 78px;
}
.h-\\[80px\\] {
  height: 80px;
}
.h-\\[90\\%\\] {
  height: 90%;
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.max-h-\\[670px\\] {
  max-height: 670px;
}
.max-h-\\[696px\\] {
  max-height: 696px;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-\\[532px\\] {
  min-height: 532px;
}
.min-h-screen {
  min-height: 100vh;
}
.w-1\\/2 {
  width: 50%;
}
.w-10 {
  width: 2.5rem;
}
.w-12 {
  width: 3rem;
}
.w-128px {
  width: 8rem;
}
.w-154px {
  width: 9.625rem;
}
.w-3\\/5 {
  width: 60%;
}
.w-3\\/6 {
  width: 50%;
}
.w-4 {
  width: 1rem;
}
.w-6 {
  width: 1.5rem;
}
.w-64 {
  width: 16rem;
}
.w-8 {
  width: 2rem;
}
.w-\\[100\\%\\] {
  width: 100%;
}
.w-\\[110px\\] {
  width: 110px;
}
.w-\\[117\\%\\] {
  width: 117%;
}
.w-\\[118px\\] {
  width: 118px;
}
.w-\\[130px\\] {
  width: 130px;
}
.w-\\[131px\\] {
  width: 131px;
}
.w-\\[133\\.33\\%\\] {
  width: 133.33%;
}
.w-\\[136px\\] {
  width: 136px;
}
.w-\\[140px\\] {
  width: 140px;
}
.w-\\[142px\\] {
  width: 142px;
}
.w-\\[143px\\] {
  width: 143px;
}
.w-\\[14px\\] {
  width: 14px;
}
.w-\\[160px\\] {
  width: 160px;
}
.w-\\[16px\\] {
  width: 16px;
}
.w-\\[171\\.878px\\] {
  width: 171.878px;
}
.w-\\[182px\\] {
  width: 182px;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[190px\\] {
  width: 190px;
}
.w-\\[213px\\] {
  width: 213px;
}
.w-\\[214px\\] {
  width: 214px;
}
.w-\\[216px\\] {
  width: 216px;
}
.w-\\[22px\\] {
  width: 22px;
}
.w-\\[23\\.125\\%\\] {
  width: 23.125%;
}
.w-\\[235px\\] {
  width: 235px;
}
.w-\\[24px\\] {
  width: 24px;
}
.w-\\[26\\.9\\%\\] {
  width: 26.9%;
}
.w-\\[264px\\] {
  width: 264px;
}
.w-\\[280px\\] {
  width: 280px;
}
.w-\\[290px\\] {
  width: 290px;
}
.w-\\[30\\.8\\%\\] {
  width: 30.8%;
}
.w-\\[30px\\] {
  width: 30px;
}
.w-\\[320px\\] {
  width: 320px;
}
.w-\\[32px\\] {
  width: 32px;
}
.w-\\[33\\%\\] {
  width: 33%;
}
.w-\\[38\\.4\\%\\] {
  width: 38.4%;
}
.w-\\[40\\%\\] {
  width: 40%;
}
.w-\\[40\\.8\\%\\] {
  width: 40.8%;
}
.w-\\[40px\\] {
  width: 40px;
}
.w-\\[42\\.557\\%\\] {
  width: 42.557%;
}
.w-\\[45\\.99\\%\\] {
  width: 45.99%;
}
.w-\\[5\\.97\\%\\] {
  width: 5.97%;
}
.w-\\[54\\.13\\%\\] {
  width: 54.13%;
}
.w-\\[54\\.225\\%\\] {
  width: 54.225%;
}
.w-\\[56\\%\\] {
  width: 56%;
}
.w-\\[6\\%\\] {
  width: 6%;
}
.w-\\[60px\\] {
  width: 60px;
}
.w-\\[61px\\] {
  width: 61px;
}
.w-\\[62px\\] {
  width: 62px;
}
.w-\\[63px\\] {
  width: 63px;
}
.w-\\[70px\\] {
  width: 70px;
}
.w-\\[71px\\] {
  width: 71px;
}
.w-\\[73px\\] {
  width: 73px;
}
.w-\\[74px\\] {
  width: 74px;
}
.w-\\[75\\.5vw\\] {
  width: 75.5vw;
}
.w-\\[80\\%\\] {
  width: 80%;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-\\[98px\\] {
  width: 98px;
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.w-screen {
  width: 100vw;
}
.min-w-\\[160px\\] {
  min-width: 160px;
}
.min-w-\\[24px\\] {
  min-width: 24px;
}
.min-w-\\[85\\.5px\\] {
  min-width: 85.5px;
}
.max-w-\\[222px\\] {
  max-width: 222px;
}
.max-w-\\[298px\\] {
  max-width: 298px;
}
.max-w-\\[333px\\] {
  max-width: 333px;
}
.max-w-\\[507px\\] {
  max-width: 507px;
}
.max-w-\\[858px\\] {
  max-width: 858px;
}
.max-w-none {
  max-width: none;
}
.max-w-xl {
  max-width: 36rem;
}
.flex-1 {
  flex: 1 1;
}
.flex-auto {
  flex: 1 1 auto;
}
.flex-none {
  flex: none;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink {
  flex-shrink: 1;
}
.flex-grow {
  flex-grow: 1;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-x-\\[50\\%\\] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[-50\\%\\] {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[20\\%\\] {
  --tw-translate-x: 20%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[40\\%\\] {
  --tw-translate-x: 40%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[50\\%\\] {
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-\\[59\\%\\] {
  --tw-translate-y: 59%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[40deg\\] {
  --tw-rotate: 40deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[0\\.75\\] {
  --tw-scale-x: 0.75;
  --tw-scale-y: 0.75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[0\\.83\\] {
  --tw-scale-x: 0.83;
  --tw-scale-y: 0.83;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[83\\%\\] {
  --tw-scale-x: 83%;
  --tw-scale-y: 83%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[91\\.67\\%\\] {
  --tw-scale-x: 91.67%;
  --tw-scale-y: 91.67%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes rightAndLeft-1 {

  0%, 100% {
    transform: translateX(0);
  }

  25% {
    transform: translateX(10px);
  }

  50% {
    transform: translateX(0);
  }

  75% {
    transform: translateX(10px);
  }
}
.animate-\\[rightAndLeft-1_2s_cubic-bezier\\(0\\2c 0\\2c 0\\2c 0\\)_infinite\\] {
  animation: rightAndLeft-1 2s cubic-bezier(0,0,0,0) infinite;
}
@keyframes rightAndLeft-2 {

  0%, 100% {
    transform: translateX(0) rotate(40deg);
  }

  25% {
    transform: translateX(-5px) rotate(40deg);
  }

  50% {
    transform: translateX(0) rotate(40deg);
  }

  75% {
    transform: translateX(5px) rotate(40deg);
  }
}
.animate-\\[rightAndLeft-2_1s_cubic-bezier\\(0\\2c 0\\2c 0\\2c 0\\)_infinite\\] {
  animation: rightAndLeft-2 1s cubic-bezier(0,0,0,0) infinite;
}
@keyframes zoomInToLeftBottom {

  0%, 100% {
    transform: scale(1) translateY(59%) translateX(-50%);
  }

  50% {
    transform: scale(1.1) translateY(59%) translateX(-50%);
  }
}
.animate-\\[zoomInToLeftBottom_2s_cubic-bezier\\(0\\.68\\2c -0\\.55\\2c 0\\.27\\2c 1\\.55\\)_infinite\\] {
  animation: zoomInToLeftBottom 2s cubic-bezier(0.68,-0.55,0.27,1.55) infinite;
}
@keyframes zoomIn {

  0%, 100% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }
}
.animate-\\[zoomIn_2s_cubic-bezier\\(0\\.68\\2c -0\\.55\\2c 0\\.27\\2c 1\\.55\\)_infinite\\] {
  animation: zoomIn 2s cubic-bezier(0.68,-0.55,0.27,1.55) infinite;
}
.cursor-default {
  cursor: default;
}
.cursor-pointer {
  cursor: pointer;
}
.resize {
  resize: both;
}
.appearance-none {
  appearance: none;
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.gap-x-\\[6vh\\] {
  column-gap: 6vh;
}
.gap-y-\\[32px\\] {
  row-gap: 32px;
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-y-scroll {
  overflow-y: scroll;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.break-words {
  overflow-wrap: break-word;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-12px {
  border-radius: 12px;
}
.rounded-15px {
  border-radius: 15px;
}
.rounded-22px {
  border-radius: 22px;
}
.rounded-30px {
  border-radius: 30px;
}
.rounded-\\[12px\\] {
  border-radius: 12px;
}
.rounded-\\[20px\\] {
  border-radius: 20px;
}
.rounded-\\[30px\\] {
  border-radius: 30px;
}
.rounded-\\[37px\\] {
  border-radius: 37px;
}
.rounded-\\[8px\\] {
  border-radius: 8px;
}
.rounded-\\[9\\.6px\\] {
  border-radius: 9.6px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-\\[1px\\] {
  border-width: 1px;
}
.border-\\[2px\\] {
  border-width: 2px;
}
.border-\\[5px\\] {
  border-width: 5px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-b-\\[0\\.67px\\] {
  border-bottom-width: 0.67px;
}
.border-b-\\[2px\\] {
  border-bottom-width: 2px;
}
.border-t-0 {
  border-top-width: 0px;
}
.border-none {
  border-style: none;
}
.border-black-11 {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
}
.border-blue-11 {
  --tw-border-opacity: 1;
  border-color: rgb(56 62 255 / var(--tw-border-opacity, 1));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-orange-2 {
  --tw-border-opacity: 1;
  border-color: rgb(252 116 84 / var(--tw-border-opacity, 1));
}
.border-pink-11 {
  --tw-border-opacity: 1;
  border-color: rgb(255 85 179 / var(--tw-border-opacity, 1));
}
.border-transparent {
  border-color: transparent;
}
.border-yellow-2 {
  --tw-border-opacity: 1;
  border-color: rgb(247 221 65 / var(--tw-border-opacity, 1));
}
.border-yellow-4 {
  --tw-border-opacity: 1;
  border-color: rgb(243 211 83 / var(--tw-border-opacity, 1));
}
.border-b-orange-2 {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(252 116 84 / var(--tw-border-opacity, 1));
}
.bg-\\[\\#EFEFEF4D\\] {
  background-color: #EFEFEF4D;
}
.bg-\\[\\#FFF\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#d8d8d8\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(216 216 216 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#febe03\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(254 190 3 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#fff\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ffffff66\\] {
  background-color: #ffffff66;
}
.bg-\\[rgba\\(0\\2c 0\\2c 0\\2c \\.6\\)\\] {
  background-color: rgba(0,0,0,.6);
}
.bg-\\[rgba\\(29\\2c 23\\2c 66\\2c \\.3\\)\\] {
  background-color: rgba(29,23,66,.3);
}
.bg-black-4 {
  --tw-bg-opacity: 1;
  background-color: rgb(29 23 66 / var(--tw-bg-opacity, 1));
}
.bg-black-5 {
  --tw-bg-opacity: 1;
  background-color: rgb(12 9 45 / var(--tw-bg-opacity, 1));
}
.bg-blue-1 {
  --tw-bg-opacity: 1;
  background-color: rgb(28 75 245 / var(--tw-bg-opacity, 1));
}
.bg-blue-11 {
  --tw-bg-opacity: 1;
  background-color: rgb(56 62 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-2 {
  --tw-bg-opacity: 1;
  background-color: rgb(18 54 184 / var(--tw-bg-opacity, 1));
}
.bg-blue-3 {
  --tw-bg-opacity: 1;
  background-color: rgb(61 97 236 / var(--tw-bg-opacity, 1));
}
.bg-gray-1 {
  --tw-bg-opacity: 1;
  background-color: rgb(84 84 84 / var(--tw-bg-opacity, 1));
}
.bg-gray-2 {
  --tw-bg-opacity: 1;
  background-color: rgb(204 204 204 / var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.bg-green-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-grey-11 {
  --tw-bg-opacity: 1;
  background-color: rgb(230 232 237 / var(--tw-bg-opacity, 1));
}
.bg-orange-2 {
  --tw-bg-opacity: 1;
  background-color: rgb(252 116 84 / var(--tw-bg-opacity, 1));
}
.bg-pink-11 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 85 179 / var(--tw-bg-opacity, 1));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-transparent {
  background-color: transparent;
}
.bg-yellow-11 {
  --tw-bg-opacity: 1;
  background-color: rgb(233 248 0 / var(--tw-bg-opacity, 1));
}
.bg-yellow-4 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 211 83 / var(--tw-bg-opacity, 1));
}
.bg-opacity-75 {
  --tw-bg-opacity: 0.75;
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.bg-mobileProcess {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.from-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\)\\] {
  --tw-gradient-from: rgba(0,0,0,0) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(0, 0, 0, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.8\\)\\] {
  --tw-gradient-from: rgba(0,0,0,0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgba(0, 0, 0, 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\)\\] {
  --tw-gradient-to: rgba(0,0,0,0) var(--tw-gradient-to-position);
}
.to-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.8\\)\\] {
  --tw-gradient-to: rgba(0,0,0,0.8) var(--tw-gradient-to-position);
}
.bg-cover {
  background-size: cover;
}
.bg-center {
  background-position: center;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.p-1 {
  padding: 0.25rem;
}
.p-10 {
  padding: 2.5rem;
}
.p-4 {
  padding: 1rem;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-10px {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-12px {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-15px {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-16px {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-30px {
  padding-left: 1.875rem;
  padding-right: 1.875rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-48px {
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-55px {
  padding-left: 3.4375rem;
  padding-right: 3.4375rem;
}
.px-85px {
  padding-left: 5.3125rem;
  padding-right: 5.3125rem;
}
.px-\\[10px\\] {
  padding-left: 10px;
  padding-right: 10px;
}
.px-\\[12px\\] {
  padding-left: 12px;
  padding-right: 12px;
}
.px-\\[14px\\] {
  padding-left: 14px;
  padding-right: 14px;
}
.px-\\[15px\\] {
  padding-left: 15px;
  padding-right: 15px;
}
.px-\\[16px\\] {
  padding-left: 16px;
  padding-right: 16px;
}
.px-\\[20px\\] {
  padding-left: 20px;
  padding-right: 20px;
}
.px-\\[3\\.7vw\\] {
  padding-left: 3.7vw;
  padding-right: 3.7vw;
}
.px-\\[40px\\] {
  padding-left: 40px;
  padding-right: 40px;
}
.px-\\[43px\\] {
  padding-left: 43px;
  padding-right: 43px;
}
.px-\\[5\\.3vw\\] {
  padding-left: 5.3vw;
  padding-right: 5.3vw;
}
.px-\\[50px\\] {
  padding-left: 50px;
  padding-right: 50px;
}
.px-\\[6px\\] {
  padding-left: 6px;
  padding-right: 6px;
}
.px-\\[7px\\] {
  padding-left: 7px;
  padding-right: 7px;
}
.py-10px {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-15px {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-17px {
  padding-top: 1.5625rem;
  padding-bottom: 1.5625rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-6px {
  padding-top: 0.325rem;
  padding-bottom: 0.325rem;
}
.py-8px {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-\\[11px\\] {
  padding-top: 11px;
  padding-bottom: 11px;
}
.py-\\[18px\\] {
  padding-top: 18px;
  padding-bottom: 18px;
}
.py-\\[1px\\] {
  padding-top: 1px;
  padding-bottom: 1px;
}
.py-\\[20px\\] {
  padding-top: 20px;
  padding-bottom: 20px;
}
.py-\\[29px\\] {
  padding-top: 29px;
  padding-bottom: 29px;
}
.py-\\[30px\\] {
  padding-top: 30px;
  padding-bottom: 30px;
}
.py-\\[32px\\] {
  padding-top: 32px;
  padding-bottom: 32px;
}
.py-\\[40px\\] {
  padding-top: 40px;
  padding-bottom: 40px;
}
.py-\\[4px\\] {
  padding-top: 4px;
  padding-bottom: 4px;
}
.py-\\[5px\\] {
  padding-top: 5px;
  padding-bottom: 5px;
}
.py-\\[6px\\] {
  padding-top: 6px;
  padding-bottom: 6px;
}
.py-\\[7\\.5px\\] {
  padding-top: 7.5px;
  padding-bottom: 7.5px;
}
.py-\\[7px\\] {
  padding-top: 7px;
  padding-bottom: 7px;
}
.py-\\[8px\\] {
  padding-top: 8px;
  padding-bottom: 8px;
}
.pb-20 {
  padding-bottom: 5rem;
}
.pb-20px {
  padding-bottom: 1.25rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-50px {
  padding-bottom: 3.125rem;
}
.pb-\\[100\\%\\] {
  padding-bottom: 100%;
}
.pb-\\[10px\\] {
  padding-bottom: 10px;
}
.pb-\\[121\\.3\\%\\] {
  padding-bottom: 121.3%;
}
.pb-\\[12px\\] {
  padding-bottom: 12px;
}
.pb-\\[14px\\] {
  padding-bottom: 14px;
}
.pb-\\[16px\\] {
  padding-bottom: 16px;
}
.pb-\\[177\\.8\\%\\] {
  padding-bottom: 177.8%;
}
.pb-\\[238\\.4\\%\\] {
  padding-bottom: 238.4%;
}
.pb-\\[27px\\] {
  padding-bottom: 27px;
}
.pb-\\[4px\\] {
  padding-bottom: 4px;
}
.pb-\\[61px\\] {
  padding-bottom: 61px;
}
.pb-\\[8px\\] {
  padding-bottom: 8px;
}
.pl-0 {
  padding-left: 0px;
}
.pl-1 {
  padding-left: 0.25rem;
}
.pl-12px {
  padding-left: 0.75rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-30px {
  padding-left: 1.875rem;
}
.pl-\\[12px\\] {
  padding-left: 12px;
}
.pl-\\[40px\\] {
  padding-left: 40px;
}
.pl-\\[8px\\] {
  padding-left: 8px;
}
.pr-100px {
  padding-right: 6.25rem;
}
.pr-10px {
  padding-right: 0.625rem;
}
.pr-15px {
  padding-right: 1.25rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-20px {
  padding-right: 1.25rem;
}
.pr-8px {
  padding-right: 0.5rem;
}
.pr-\\[10px\\] {
  padding-right: 10px;
}
.pr-\\[26px\\] {
  padding-right: 26px;
}
.pt-10px {
  padding-top: 0.625rem;
}
.pt-280px {
  padding-top: 17.5rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-44px {
  padding-top: 2.75rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-\\[10px\\] {
  padding-top: 10px;
}
.pt-\\[11px\\] {
  padding-top: 11px;
}
.pt-\\[12px\\] {
  padding-top: 12px;
}
.pt-\\[16px\\] {
  padding-top: 16px;
}
.pt-\\[20px\\] {
  padding-top: 20px;
}
.pt-\\[27px\\] {
  padding-top: 27px;
}
.pt-\\[32px\\] {
  padding-top: 32px;
}
.pt-\\[34px\\] {
  padding-top: 34px;
}
.pt-\\[40px\\] {
  padding-top: 40px;
}
.pt-\\[45px\\] {
  padding-top: 45px;
}
.pt-\\[4px\\] {
  padding-top: 4px;
}
.pt-\\[5px\\] {
  padding-top: 5px;
}
.pt-\\[64px\\] {
  padding-top: 64px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.align-bottom {
  vertical-align: bottom;
}
.font-NotoSansTC {
  font-family: Noto Sans TC;
}
.text-10px {
  font-size: 0.625rem;
}
.text-12px {
  font-size: 0.75rem;
}
.text-14px {
  font-size: 0.875rem;
}
.text-15px {
  font-size: 0.9375rem;
}
.text-18px {
  font-size: 1.125rem;
}
.text-20px {
  font-size: 1.25rem;
}
.text-22px {
  font-size: 1.375rem;
}
.text-24px {
  font-size: 1.5rem;
}
.text-30px {
  font-size: 1.875rem;
}
.text-32px {
  font-size: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[24px\\] {
  font-size: 24px;
}
.text-\\[25px\\] {
  font-size: 25px;
}
.text-\\[26px\\] {
  font-size: 26px;
}
.text-\\[28px\\] {
  font-size: 28px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-black {
  font-weight: 900;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-extralight {
  font-weight: 200;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.italic {
  font-style: italic;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-\\[36px\\] {
  line-height: 36px;
}
.leading-loose {
  line-height: 2;
}
.leading-none {
  line-height: 1;
}
.leading-normal {
  line-height: 1.5;
}
.tracking-\\[0\\.92px\\] {
  letter-spacing: 0.92px;
}
.tracking-\\[1\\.12px\\] {
  letter-spacing: 1.12px;
}
.tracking-\\[1\\.17px\\] {
  letter-spacing: 1.17px;
}
.tracking-\\[1\\.58px\\] {
  letter-spacing: 1.58px;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.text-\\[\\#000\\] {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1D1742\\] {
  --tw-text-opacity: 1;
  color: rgb(29 23 66 / var(--tw-text-opacity, 1));
}
.text-\\[\\#434343\\] {
  --tw-text-opacity: 1;
  color: rgb(67 67 67 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FF55B3\\] {
  --tw-text-opacity: 1;
  color: rgb(255 85 179 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FFF\\] {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-black-1 {
  --tw-text-opacity: 1;
  color: rgb(40 40 40 / var(--tw-text-opacity, 1));
}
.text-black-11 {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-black-2 {
  --tw-text-opacity: 1;
  color: rgb(52 52 52 / var(--tw-text-opacity, 1));
}
.text-black-4 {
  --tw-text-opacity: 1;
  color: rgb(29 23 66 / var(--tw-text-opacity, 1));
}
.text-blue-1 {
  --tw-text-opacity: 1;
  color: rgb(28 75 245 / var(--tw-text-opacity, 1));
}
.text-blue-11 {
  --tw-text-opacity: 1;
  color: rgb(56 62 255 / var(--tw-text-opacity, 1));
}
.text-blue-3 {
  --tw-text-opacity: 1;
  color: rgb(61 97 236 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-indigo-600 {
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-orange-1 {
  --tw-text-opacity: 1;
  color: rgb(250 116 96 / var(--tw-text-opacity, 1));
}
.text-orange-2 {
  --tw-text-opacity: 1;
  color: rgb(252 116 84 / var(--tw-text-opacity, 1));
}
.text-pink-11 {
  --tw-text-opacity: 1;
  color: rgb(255 85 179 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity, 1));
}
.text-white-1 {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-yellow-3 {
  --tw-text-opacity: 1;
  color: rgb(255 224 0 / var(--tw-text-opacity, 1));
}
.text-yellow-4 {
  --tw-text-opacity: 1;
  color: rgb(243 211 83 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.placeholder-black-6::placeholder {
  color: rgba(29,23,66,.5);
}
.placeholder-gray-500::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(107 114 128 / var(--tw-placeholder-opacity, 1));
}
.placeholder-orange-2::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(252 116 84 / var(--tw-placeholder-opacity, 1));
}
.placeholder-yellow-2::placeholder {
  --tw-placeholder-opacity: 1;
  color: rgb(247 221 65 / var(--tw-placeholder-opacity, 1));
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[6px_9px_0_0_rgba\\(213\\2c 213\\2c 213\\2c 1\\)\\] {
  --tw-shadow: 6px 9px 0 0 rgba(213,213,213,1);
  --tw-shadow-colored: 6px 9px 0 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-superButton {
  --tw-shadow: 0 0 10px 1px rgba(243, 211,83,0.4);
  --tw-shadow-colored: 0 0 10px 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.drop-shadow {
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-superButton {
  --tw-drop-shadow: drop-shadow(0 0 10px 1px rgba(243, 211,83,0.4));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
@font-face {
  font-family: GenSenRoundedTW-M;
  src: local("GenSenRoundedTW-M"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: GenYoGothic-B;
  src: local("GenYoGothic-B"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
@font-face {
  font-family: GenYoGothic-H;
  src: local("GenYoGothic-H"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
@font-face {
  font-family: GenYoGothic-M;
  src: local("GenYoGothic-M"),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
}
@font-face {
  font-family: DelaGothicOne;
  src: local("DelaGothicOne"),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
}
@font-face {
  font-family: LINESeedJP_TTF_Bd;
  src: local("LINESeedJP_TTF_Bd"),
    url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
}
@font-face {
  font-family: LINESeedJP_TTF_Eb;
  src: local("LINESeedJP_TTF_Eb"),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
}
@font-face {
  font-family: LINESeedJP_TTF_Rg;
  src: local("LINESeedJP_TTF_Rg"),
    url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
}
@font-face {
  font-family: LINESeedJP_TTF_Th;
  src: local("LINESeedJP_TTF_Th"),
    url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
}
html {
  text-size-adjust: none;
  -webkit-text-size-adjust: none;
  -ms-text-size-adjust: none;
  -moz-text-size-adjust: none;
  font-size-adjust: none;
    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox */
}
html::-webkit-scrollbar { 
    display: none;  /* Safari and Chrome */
}
body {
  font-family: GenSenRoundedTW-M;
}

.slick-dots {
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 0.5rem 0;
  list-style-type: none;
}
.slick-dots li {
  width: 5px;
  height: 5px;
  margin: 0 0.2rem;
}
.slick-dots li button {
  display: block;
  width: 8px;
  height: 8px;
  padding: 0;

  border: none;
  border-radius: 100%;
  background-color: #c4c4c4;

  text-indent: -9999px;
}
li.slick-active button {
  background-color: #282828;
}
@media (max-width: 510px) {
  .slick-dots {
    padding: 0.8rem 0;
  }
  .slick-dots li button {
    width: 5px;
    height: 5px;
  }
}
.c-mask {
  background: linear-gradient(
    to bottom,
    transparent 0%,
    rgba(0, 0, 0, 0.6) 81%
  );
  margin-top: auto;
  padding: 30px 15px 18px;
  border-radius: 0 0 4px 4px;
  flex-shrink: 0;
}
/* 字體 */
.font-GenYoGothic-B {
  font-family: GenYoGothic-B;
}
.font-GenYoGothic-H {
  font-family: GenYoGothic-H;
}
.font-GenYoGothic-M {
  font-family: GenYoGothic-M;
}
.font-DelaGothicOne {
  font-family: DelaGothicOne;
}

.font-LINESeedJP_TTF_Bd {
  font-family: LINESeedJP_TTF_Bd;
}
.font-LINESeedJP_TTF_Eb {
  font-family: LINESeedJP_TTF_Eb;
}
.font-LINESeedJP_TTF_Rg {
  font-family: LINESeedJP_TTF_Rg;
}
.font-LINESeedJP_TTF_Th {
  font-family: LINESeedJP_TTF_Th;
}
input[type="range"],
input[type="range"]::-webkit-slider-runnable-track,
input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
}
input[type="range"] {
  height: 20px;
  width: 100%;
  overflow: hidden;
  border-radius: 10px;
  cursor: pointer; /* 滑鼠放上會改變鼠標樣式 */
  outline: none; /* 取消底線效果 */
  background-color: white;
}
/* 滑動軌道 樣式 */
input[type="range"]::-webkit-slider-runnable-track {
  height: 10px;
  width: 100%;
  border-radius: 4px;
  background: #aaa;
}
/* 滑動鈕 樣式 */
input[type="range"]::-webkit-slider-thumb {
  position: relative;
  height: 15px;
  width: 15px;
  margin-top: -3px;
  background-color: white; /* 為了解釋方便所設定 */
  /* background-color: white; */ /* 我的目標樣式 */
  border-radius: 50%;
  /* border: 1px solid black; */
}


.video-player__volume {
  position: relative;
  width: 50px;
  height: 80px;
  margin-left: 10px;
  }
  
  .video-player__volume-container {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 60px;
  background-color: #eee;
  border-radius: 5px;
  cursor: pointer;
  }
  
  .video-player__volume-filled {
  width: 100%;
  background-color: #333;
  border-radius: 5px;
  transform-origin: bottom;
  transition: transform 0.2s ease;
  }
  
  .file\\:mr-4::file-selector-button {
  margin-right: 1rem;
}
  
  .file\\:rounded-full::file-selector-button {
  border-radius: 9999px;
}
  
  .file\\:border-0::file-selector-button {
  border-width: 0px;
}
  
  .file\\:bg-violet-50::file-selector-button {
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity, 1));
}
  
  .file\\:px-4::file-selector-button {
  padding-left: 1rem;
  padding-right: 1rem;
}
  
  .file\\:py-2::file-selector-button {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
  
  .file\\:text-sm::file-selector-button {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
  
  .file\\:font-semibold::file-selector-button {
  font-weight: 600;
}
  
  .file\\:text-violet-700::file-selector-button {
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}
  
  .placeholder\\:text-black-11::placeholder {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
  
  .placeholder\\:text-yellow-4::placeholder {
  --tw-text-opacity: 1;
  color: rgb(243 211 83 / var(--tw-text-opacity, 1));
}
  
  .before\\:ml-0\\.5::before {
  content: var(--tw-content);
  margin-left: 0.125rem;
}
  
  .before\\:text-\\[\\#FE666C\\]::before {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: rgb(254 102 108 / var(--tw-text-opacity, 1));
}
  
  .before\\:text-red-500::before {
  content: var(--tw-content);
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
  
  .before\\:content-\\[\\'\\*\\'\\]::before {
  --tw-content: '*';
  content: var(--tw-content);
}
  
  .first\\:pt-0:first-child {
  padding-top: 0px;
}
  
  .last\\:border-b-0:last-child {
  border-bottom-width: 0px;
}
  
  .last\\:border-b-transparent:last-child {
  border-bottom-color: transparent;
}
  
  .hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
  
  .hover\\:bg-blue-2:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(18 54 184 / var(--tw-bg-opacity, 1));
}
  
  .hover\\:bg-gray-2:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(204 204 204 / var(--tw-bg-opacity, 1));
}
  
  .hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
  
  .hover\\:bg-indigo-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1));
}
  
  .hover\\:bg-yellow-4:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(243 211 83 / var(--tw-bg-opacity, 1));
}
  
  .hover\\:text-gray-900:hover {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
  
  .hover\\:text-yellow-3:hover {
  --tw-text-opacity: 1;
  color: rgb(255 224 0 / var(--tw-text-opacity, 1));
}
  
  .hover\\:file\\:bg-violet-100::file-selector-button:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(237 233 254 / var(--tw-bg-opacity, 1));
}
  
  .focus\\:z-10:focus {
  z-index: 10;
}
  
  .focus\\:border-indigo-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
  
  .focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
  
  .focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
  
  .focus\\:ring-indigo-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}
  
  .focus\\:ring-offset-2:focus {
  --tw-ring-offset-width: 2px;
}
  
  .group:hover .group-hover\\:block {
  display: block;
}
  
  .group:hover .group-hover\\:hidden {
  display: none;
}
  
  @media (min-width: 640px) {

  .sm\\:absolute {
    position: absolute;
  }

  .sm\\:inset-x-0 {
    left: 0px;
    right: 0px;
  }

  .sm\\:-right-\\[36px\\] {
    right: -36px;
  }

  .sm\\:-right-\\[46px\\] {
    right: -46px;
  }

  .sm\\:-right-\\[47px\\] {
    right: -47px;
  }

  .sm\\:bottom-0 {
    bottom: 0px;
  }

  .sm\\:bottom-\\[-1\\%\\] {
    bottom: -1%;
  }

  .sm\\:bottom-\\[0\\] {
    bottom: 0;
  }

  .sm\\:bottom-\\[16px\\] {
    bottom: 16px;
  }

  .sm\\:bottom-\\[19\\%\\] {
    bottom: 19%;
  }

  .sm\\:bottom-\\[3\\.99\\%\\] {
    bottom: 3.99%;
  }

  .sm\\:bottom-\\[58px\\] {
    bottom: 58px;
  }

  .sm\\:left-0 {
    left: 0px;
  }

  .sm\\:left-\\[-17px\\] {
    left: -17px;
  }

  .sm\\:left-\\[0\\] {
    left: 0;
  }

  .sm\\:left-\\[15px\\] {
    left: 15px;
  }

  .sm\\:left-\\[8\\%\\] {
    left: 8%;
  }

  .sm\\:right-45px {
    right: 45px;
  }

  .sm\\:right-\\[1\\%\\] {
    right: 1%;
  }

  .sm\\:right-\\[10\\%\\] {
    right: 10%;
  }

  .sm\\:right-\\[12px\\] {
    right: 12px;
  }

  .sm\\:right-\\[13px\\] {
    right: 13px;
  }

  .sm\\:right-\\[18px\\] {
    right: 18px;
  }

  .sm\\:right-\\[21\\.1\\%\\] {
    right: 21.1%;
  }

  .sm\\:right-\\[38px\\] {
    right: 38px;
  }

  .sm\\:right-\\[7\\%\\] {
    right: 7%;
  }

  .sm\\:right-\\[8px\\] {
    right: 8px;
  }

  .sm\\:top-0 {
    top: 0px;
  }

  .sm\\:top-20px {
    top: 20px;
  }

  .sm\\:top-\\[-9vw\\] {
    top: -9vw;
  }

  .sm\\:top-\\[11\\.5\\%\\] {
    top: 11.5%;
  }

  .sm\\:top-\\[12px\\] {
    top: 12px;
  }

  .sm\\:top-\\[14\\.1\\%\\] {
    top: 14.1%;
  }

  .sm\\:top-\\[15\\.5\\%\\] {
    top: 15.5%;
  }

  .sm\\:top-\\[24px\\] {
    top: 24px;
  }

  .sm\\:top-\\[27\\%\\] {
    top: 27%;
  }

  .sm\\:top-\\[30px\\] {
    top: 30px;
  }

  .sm\\:top-\\[47\\.44\\%\\] {
    top: 47.44%;
  }

  .sm\\:top-\\[71px\\] {
    top: 71px;
  }

  .sm\\:top-\\[8px\\] {
    top: 8px;
  }

  .sm\\:m-0 {
    margin: 0px;
  }

  .sm\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:mx-12px {
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }

  .sm\\:my-8 {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .sm\\:mb-24px {
    margin-bottom: 1.5rem;
  }

  .sm\\:mb-36px {
    margin-bottom: 2rem;
  }

  .sm\\:mb-\\[0\\] {
    margin-bottom: 0;
  }

  .sm\\:mb-\\[120px\\] {
    margin-bottom: 120px;
  }

  .sm\\:mb-\\[12px\\] {
    margin-bottom: 12px;
  }

  .sm\\:mb-\\[22px\\] {
    margin-bottom: 22px;
  }

  .sm\\:mb-\\[25px\\] {
    margin-bottom: 25px;
  }

  .sm\\:mb-\\[27px\\] {
    margin-bottom: 27px;
  }

  .sm\\:mb-\\[32px\\] {
    margin-bottom: 32px;
  }

  .sm\\:mb-\\[48px\\] {
    margin-bottom: 48px;
  }

  .sm\\:mb-\\[5px\\] {
    margin-bottom: 5px;
  }

  .sm\\:mb-\\[60px\\] {
    margin-bottom: 60px;
  }

  .sm\\:mb-\\[67px\\] {
    margin-bottom: 67px;
  }

  .sm\\:mb-\\[70px\\] {
    margin-bottom: 70px;
  }

  .sm\\:ml-0 {
    margin-left: 0px;
  }

  .sm\\:ml-3 {
    margin-left: 0.75rem;
  }

  .sm\\:ml-4 {
    margin-left: 1rem;
  }

  .sm\\:ml-\\[0\\] {
    margin-left: 0;
  }

  .sm\\:ml-\\[11px\\] {
    margin-left: 11px;
  }

  .sm\\:ml-\\[145px\\] {
    margin-left: 145px;
  }

  .sm\\:ml-\\[8px\\] {
    margin-left: 8px;
  }

  .sm\\:mr-0 {
    margin-right: 0px;
  }

  .sm\\:mr-\\[0\\] {
    margin-right: 0;
  }

  .sm\\:mr-\\[24px\\] {
    margin-right: 24px;
  }

  .sm\\:mr-\\[46px\\] {
    margin-right: 46px;
  }

  .sm\\:mr-\\[8px\\] {
    margin-right: 8px;
  }

  .sm\\:mt-0 {
    margin-top: 0px;
  }

  .sm\\:mt-0px {
    margin-top: 0rem;
  }

  .sm\\:mt-10px {
    margin-top: 0.625rem;
  }

  .sm\\:mt-2 {
    margin-top: 0.5rem;
  }

  .sm\\:mt-20px {
    margin-top: 1.25rem;
  }

  .sm\\:mt-24px {
    margin-top: 1.5rem;
  }

  .sm\\:mt-94px {
    margin-top: 5.875rem;
  }

  .sm\\:mt-\\[-3vw\\] {
    margin-top: -3vw;
  }

  .sm\\:mt-\\[0\\] {
    margin-top: 0;
  }

  .sm\\:mt-\\[0px\\] {
    margin-top: 0px;
  }

  .sm\\:mt-\\[12px\\] {
    margin-top: 12px;
  }

  .sm\\:mt-\\[16px\\] {
    margin-top: 16px;
  }

  .sm\\:mt-\\[17px\\] {
    margin-top: 17px;
  }

  .sm\\:mt-\\[23px\\] {
    margin-top: 23px;
  }

  .sm\\:mt-\\[24px\\] {
    margin-top: 24px;
  }

  .sm\\:mt-\\[30px\\] {
    margin-top: 30px;
  }

  .sm\\:mt-\\[61px\\] {
    margin-top: 61px;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:inline-block {
    display: inline-block;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:contents {
    display: contents;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:h-10 {
    height: 2.5rem;
  }

  .sm\\:h-242px {
    height: 15.125rem;
  }

  .sm\\:h-50px {
    height: 3.125rem;
  }

  .sm\\:h-64px {
    height: 4rem;
  }

  .sm\\:h-\\[22px\\] {
    height: 22px;
  }

  .sm\\:h-\\[284px\\] {
    height: 284px;
  }

  .sm\\:h-\\[28px\\] {
    height: 28px;
  }

  .sm\\:h-\\[29px\\] {
    height: 29px;
  }

  .sm\\:h-\\[2px\\] {
    height: 2px;
  }

  .sm\\:h-\\[40px\\] {
    height: 40px;
  }

  .sm\\:h-\\[41px\\] {
    height: 41px;
  }

  .sm\\:h-\\[47px\\] {
    height: 47px;
  }

  .sm\\:h-\\[50px\\] {
    height: 50px;
  }

  .sm\\:h-\\[60px\\] {
    height: 60px;
  }

  .sm\\:h-\\[64px\\] {
    height: 64px;
  }

  .sm\\:h-\\[65px\\] {
    height: 65px;
  }

  .sm\\:h-auto {
    height: auto;
  }

  .sm\\:h-full {
    height: 100%;
  }

  .sm\\:h-screen {
    height: 100vh;
  }

  .sm\\:min-h-\\[380px\\] {
    min-height: 380px;
  }

  .sm\\:w-1\\/2 {
    width: 50%;
  }

  .sm\\:w-10 {
    width: 2.5rem;
  }

  .sm\\:w-242px {
    width: 15.125rem;
  }

  .sm\\:w-296px {
    width: 18.5rem;
  }

  .sm\\:w-3\\/6 {
    width: 50%;
  }

  .sm\\:w-4\\/6 {
    width: 66.666667%;
  }

  .sm\\:w-\\[116px\\] {
    width: 116px;
  }

  .sm\\:w-\\[127px\\] {
    width: 127px;
  }

  .sm\\:w-\\[155px\\] {
    width: 155px;
  }

  .sm\\:w-\\[160px\\] {
    width: 160px;
  }

  .sm\\:w-\\[176px\\] {
    width: 176px;
  }

  .sm\\:w-\\[18px\\] {
    width: 18px;
  }

  .sm\\:w-\\[2\\.57\\%\\] {
    width: 2.57%;
  }

  .sm\\:w-\\[20\\.69\\%\\] {
    width: 20.69%;
  }

  .sm\\:w-\\[22px\\] {
    width: 22px;
  }

  .sm\\:w-\\[244px\\] {
    width: 244px;
  }

  .sm\\:w-\\[250px\\] {
    width: 250px;
  }

  .sm\\:w-\\[271px\\] {
    width: 271px;
  }

  .sm\\:w-\\[28\\.5\\%\\] {
    width: 28.5%;
  }

  .sm\\:w-\\[280px\\] {
    width: 280px;
  }

  .sm\\:w-\\[284px\\] {
    width: 284px;
  }

  .sm\\:w-\\[30\\.8\\%\\] {
    width: 30.8%;
  }

  .sm\\:w-\\[304px\\] {
    width: 304px;
  }

  .sm\\:w-\\[35\\.2\\%\\] {
    width: 35.2%;
  }

  .sm\\:w-\\[36\\.25\\%\\] {
    width: 36.25%;
  }

  .sm\\:w-\\[36px\\] {
    width: 36px;
  }

  .sm\\:w-\\[4\\%\\] {
    width: 4%;
  }

  .sm\\:w-\\[40px\\] {
    width: 40px;
  }

  .sm\\:w-\\[50px\\] {
    width: 50px;
  }

  .sm\\:w-\\[59\\.5\\%\\] {
    width: 59.5%;
  }

  .sm\\:w-\\[60\\%\\] {
    width: 60%;
  }

  .sm\\:w-\\[60px\\] {
    width: 60px;
  }

  .sm\\:w-\\[64\\.375\\%\\] {
    width: 64.375%;
  }

  .sm\\:w-\\[645px\\] {
    width: 645px;
  }

  .sm\\:w-\\[655px\\] {
    width: 655px;
  }

  .sm\\:w-\\[656px\\] {
    width: 656px;
  }

  .sm\\:w-\\[670px\\] {
    width: 670px;
  }

  .sm\\:w-\\[75\\%\\] {
    width: 75%;
  }

  .sm\\:w-\\[78\\.2\\%\\] {
    width: 78.2%;
  }

  .sm\\:w-\\[80\\%\\] {
    width: 80%;
  }

  .sm\\:w-\\[85\\%\\] {
    width: 85%;
  }

  .sm\\:w-\\[94px\\] {
    width: 94px;
  }

  .sm\\:w-\\[96px\\] {
    width: 96px;
  }

  .sm\\:w-\\[calc\\(100vw\\/1440\\*222\\)\\] {
    width: calc(100vw / 1440 * 222);
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:w-full {
    width: 100%;
  }

  .sm\\:max-w-lg {
    max-width: 32rem;
  }

  .sm\\:translate-x-\\[0\\] {
    --tw-translate-x: 0;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:scale-\\[1\\] {
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }

  .sm\\:flex-row-reverse {
    flex-direction: row-reverse;
  }

  .sm\\:flex-wrap {
    flex-wrap: wrap;
  }

  .sm\\:items-start {
    align-items: flex-start;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-center {
    justify-content: center;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:gap-y-\\[64px\\] {
    row-gap: 64px;
  }

  .sm\\:overflow-hidden {
    overflow: hidden;
  }

  .sm\\:rounded-15px {
    border-radius: 15px;
  }

  .sm\\:rounded-\\[12px\\] {
    border-radius: 12px;
  }

  .sm\\:rounded-\\[24px\\] {
    border-radius: 24px;
  }

  .sm\\:rounded-\\[40px\\] {
    border-radius: 40px;
  }

  .sm\\:border-\\[2px\\] {
    border-width: 2px;
  }

  .sm\\:border-\\[8px\\] {
    border-width: 8px;
  }

  .sm\\:bg-transparent {
    background-color: transparent;
  }

  .sm\\:bg-webProcess {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  }

  .sm\\:p-0 {
    padding: 0px;
  }

  .sm\\:p-1 {
    padding: 0.25rem;
  }

  .sm\\:p-4 {
    padding: 1rem;
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .sm\\:px-10px {
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }

  .sm\\:px-150px {
    padding-left: 9.375rem;
    padding-right: 9.375rem;
  }

  .sm\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-99px {
    padding-left: 6.1875rem;
    padding-right: 6.1875rem;
  }

  .sm\\:px-\\[20px\\] {
    padding-left: 20px;
    padding-right: 20px;
  }

  .sm\\:px-\\[37px\\] {
    padding-left: 37px;
    padding-right: 37px;
  }

  .sm\\:px-\\[44px\\] {
    padding-left: 44px;
    padding-right: 44px;
  }

  .sm\\:px-\\[58px\\] {
    padding-left: 58px;
    padding-right: 58px;
  }

  .sm\\:px-\\[80px\\] {
    padding-left: 80px;
    padding-right: 80px;
  }

  .sm\\:py-15px {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .sm\\:py-8px {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .sm\\:py-\\[13px\\] {
    padding-top: 13px;
    padding-bottom: 13px;
  }

  .sm\\:py-\\[32px\\] {
    padding-top: 32px;
    padding-bottom: 32px;
  }

  .sm\\:py-\\[64px\\] {
    padding-top: 64px;
    padding-bottom: 64px;
  }

  .sm\\:py-\\[6px\\] {
    padding-top: 6px;
    padding-bottom: 6px;
  }

  .sm\\:py-\\[80px\\] {
    padding-top: 80px;
    padding-bottom: 80px;
  }

  .sm\\:pb-100px {
    padding-bottom: 6.25rem;
  }

  .sm\\:pb-4 {
    padding-bottom: 1rem;
  }

  .sm\\:pb-\\[16px\\] {
    padding-bottom: 16px;
  }

  .sm\\:pb-\\[20px\\] {
    padding-bottom: 20px;
  }

  .sm\\:pb-\\[35px\\] {
    padding-bottom: 35px;
  }

  .sm\\:pb-\\[48\\.28\\%\\] {
    padding-bottom: 48.28%;
  }

  .sm\\:pb-\\[69\\.58\\%\\] {
    padding-bottom: 69.58%;
  }

  .sm\\:pb-\\[8px\\] {
    padding-bottom: 8px;
  }

  .sm\\:pb-\\[9px\\] {
    padding-bottom: 9px;
  }

  .sm\\:pl-0 {
    padding-left: 0px;
  }

  .sm\\:pl-\\[10px\\] {
    padding-left: 10px;
  }

  .sm\\:pl-\\[18px\\] {
    padding-left: 18px;
  }

  .sm\\:pl-\\[20px\\] {
    padding-left: 20px;
  }

  .sm\\:pl-\\[48px\\] {
    padding-left: 48px;
  }

  .sm\\:pl-\\[53px\\] {
    padding-left: 53px;
  }

  .sm\\:pl-\\[7\\.2vw\\] {
    padding-left: 7.2vw;
  }

  .sm\\:pr-100px {
    padding-right: 6.25rem;
  }

  .sm\\:pr-15px {
    padding-right: 1.25rem;
  }

  .sm\\:pr-\\[16px\\] {
    padding-right: 16px;
  }

  .sm\\:pr-\\[32px\\] {
    padding-right: 32px;
  }

  .sm\\:pr-\\[40px\\] {
    padding-right: 40px;
  }

  .sm\\:pr-\\[41px\\] {
    padding-right: 41px;
  }

  .sm\\:pr-\\[44px\\] {
    padding-right: 44px;
  }

  .sm\\:pt-0 {
    padding-top: 0px;
  }

  .sm\\:pt-150px {
    padding-top: 9.375rem;
  }

  .sm\\:pt-\\[11px\\] {
    padding-top: 11px;
  }

  .sm\\:pt-\\[128px\\] {
    padding-top: 128px;
  }

  .sm\\:pt-\\[14px\\] {
    padding-top: 14px;
  }

  .sm\\:pt-\\[22px\\] {
    padding-top: 22px;
  }

  .sm\\:pt-\\[23px\\] {
    padding-top: 23px;
  }

  .sm\\:pt-\\[24px\\] {
    padding-top: 24px;
  }

  .sm\\:pt-\\[27px\\] {
    padding-top: 27px;
  }

  .sm\\:pt-\\[32px\\] {
    padding-top: 32px;
  }

  .sm\\:pt-\\[40px\\] {
    padding-top: 40px;
  }

  .sm\\:pt-\\[48px\\] {
    padding-top: 48px;
  }

  .sm\\:pt-\\[5px\\] {
    padding-top: 5px;
  }

  .sm\\:pt-\\[70px\\] {
    padding-top: 70px;
  }

  .sm\\:pt-\\[77px\\] {
    padding-top: 77px;
  }

  .sm\\:pt-\\[90px\\] {
    padding-top: 90px;
  }

  .sm\\:text-left {
    text-align: left;
  }

  .sm\\:text-center {
    text-align: center;
  }

  .sm\\:align-middle {
    vertical-align: middle;
  }

  .sm\\:text-14px {
    font-size: 0.875rem;
  }

  .sm\\:text-18px {
    font-size: 1.125rem;
  }

  .sm\\:text-20px {
    font-size: 1.25rem;
  }

  .sm\\:text-24px {
    font-size: 1.5rem;
  }

  .sm\\:text-32px {
    font-size: 2rem;
  }

  .sm\\:text-33px {
    font-size: 2.0625rem;
  }

  .sm\\:text-36px {
    font-size: 2.25rem;
  }

  .sm\\:text-\\[16px\\] {
    font-size: 16px;
  }

  .sm\\:text-\\[18px\\] {
    font-size: 18px;
  }

  .sm\\:text-\\[20px\\] {
    font-size: 20px;
  }

  .sm\\:text-\\[22px\\] {
    font-size: 22px;
  }

  .sm\\:text-\\[24px\\] {
    font-size: 24px;
  }

  .sm\\:text-\\[28px\\] {
    font-size: 28px;
  }

  .sm\\:text-\\[32px\\] {
    font-size: 32px;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .sm\\:font-bold {
    font-weight: 700;
  }

  .sm\\:font-normal {
    font-weight: 400;
  }

  .sm\\:font-semibold {
    font-weight: 600;
  }

  .sm\\:leading-50px {
    line-height: 3.125rem;
  }

  .sm\\:leading-\\[36px\\] {
    line-height: 36px;
  }

  .sm\\:leading-normal {
    line-height: 1.5;
  }

  .sm\\:tracking-\\[1\\.83px\\] {
    letter-spacing: 1.83px;
  }

  .sm\\:tracking-\\[1\\.92px\\] {
    letter-spacing: 1.92px;
  }

  .sm\\:tracking-\\[2\\.53px\\] {
    letter-spacing: 2.53px;
  }

  .sm\\:opacity-0 {
    opacity: 0;
  }

  .sm\\:duration-300 {
    transition-duration: 300ms;
  }

  .group:hover .sm\\:group-hover\\:opacity-100 {
    opacity: 1;
  }
}
  
  @media (min-width: 768px) {

  .md\\:-bottom-\\[4\\.46\\%\\] {
    bottom: -4.46%;
  }

  .md\\:-left-\\[11\\.31\\%\\] {
    left: -11.31%;
  }

  .md\\:-left-\\[34px\\] {
    left: -34px;
  }

  .md\\:-top-\\[22px\\] {
    top: -22px;
  }

  .md\\:ml-\\[40px\\] {
    margin-left: 40px;
  }

  .md\\:mr-\\[12px\\] {
    margin-right: 12px;
  }

  .md\\:mr-\\[16px\\] {
    margin-right: 16px;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:mt-0px {
    margin-top: 0rem;
  }

  .md\\:block {
    display: block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-0 {
    height: 0px;
  }

  .md\\:h-\\[44px\\] {
    height: 44px;
  }

  .md\\:h-\\[45\\.4px\\] {
    height: 45.4px;
  }

  .md\\:h-\\[504\\.98px\\] {
    height: 504.98px;
  }

  .md\\:h-\\[83px\\] {
    height: 83px;
  }

  .md\\:w-\\[129px\\] {
    width: 129px;
  }

  .md\\:w-\\[130px\\] {
    width: 130px;
  }

  .md\\:w-\\[152px\\] {
    width: 152px;
  }

  .md\\:w-\\[20\\.69\\%\\] {
    width: 20.69%;
  }

  .md\\:w-\\[288px\\] {
    width: 288px;
  }

  .md\\:w-\\[43\\.155\\%\\] {
    width: 43.155%;
  }

  .md\\:w-full {
    width: 100%;
  }

  .md\\:min-w-\\[104\\.5px\\] {
    min-width: 104.5px;
  }

  .md\\:max-w-\\[479px\\] {
    max-width: 479px;
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:justify-start {
    justify-content: flex-start;
  }

  .md\\:border-b {
    border-bottom-width: 1px;
  }

  .md\\:py-85px {
    padding-top: 5.3125rem;
    padding-bottom: 5.3125rem;
  }

  .md\\:pb-\\[14px\\] {
    padding-bottom: 14px;
  }

  .md\\:pb-\\[177\\.8\\%\\] {
    padding-bottom: 177.8%;
  }

  .md\\:pb-\\[20px\\] {
    padding-bottom: 20px;
  }

  .md\\:pb-\\[6px\\] {
    padding-bottom: 6px;
  }

  .md\\:pb-\\[70px\\] {
    padding-bottom: 70px;
  }

  .md\\:pt-0 {
    padding-top: 0px;
  }

  .md\\:pt-\\[24px\\] {
    padding-top: 24px;
  }

  .md\\:pt-\\[58px\\] {
    padding-top: 58px;
  }

  .md\\:text-18px {
    font-size: 1.125rem;
  }

  .md\\:text-20px {
    font-size: 1.25rem;
  }

  .md\\:text-28px {
    font-size: 1.75rem;
  }

  .md\\:text-\\[18px\\] {
    font-size: 18px;
  }

  .md\\:text-\\[20px\\] {
    font-size: 20px;
  }
}
  
  @media (min-width: 1024px) {

  .lg\\:bottom-\\[24\\.3\\%\\] {
    bottom: 24.3%;
  }

  .lg\\:ml-\\[210px\\] {
    margin-left: 210px;
  }

  .lg\\:ml-\\[64px\\] {
    margin-left: 64px;
  }

  .lg\\:mt-0 {
    margin-top: 0px;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:h-154px {
    height: 9.625rem;
  }

  .lg\\:w-1\\/2 {
    width: 50%;
  }

  .lg\\:w-1\\/3 {
    width: 33.333333%;
  }

  .lg\\:w-154px {
    width: 9.625rem;
  }

  .lg\\:w-\\[342px\\] {
    width: 342px;
  }

  .lg\\:w-auto {
    width: auto;
  }

  .lg\\:w-full {
    width: 100%;
  }

  .lg\\:flex-wrap {
    flex-wrap: wrap;
  }

  .lg\\:items-start {
    align-items: flex-start;
  }

  .lg\\:items-end {
    align-items: flex-end;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:justify-end {
    justify-content: flex-end;
  }

  .lg\\:justify-center {
    justify-content: center;
  }

  .lg\\:bg-transparent {
    background-color: transparent;
  }

  .lg\\:p-0 {
    padding: 0px;
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:px-\\[116px\\] {
    padding-left: 116px;
    padding-right: 116px;
  }

  .lg\\:px-\\[53px\\] {
    padding-left: 53px;
    padding-right: 53px;
  }

  .lg\\:pr-10px {
    padding-right: 0.625rem;
  }

  .lg\\:pr-20px {
    padding-right: 1.25rem;
  }

  .lg\\:text-\\[14px\\] {
    font-size: 14px;
  }
}
  
  @media (min-width: 1280px) {

  .xl\\:mx-12px {
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }

  .xl\\:h-342px {
    height: 21.375rem;
  }

  .xl\\:w-342px {
    width: 21.375rem;
  }

  .xl\\:w-375px {
    width: 23.4375rem;
  }

  .xl\\:px-15px {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .xl\\:px-\\[6\\.1vw\\] {
    padding-left: 6.1vw;
    padding-right: 6.1vw;
  }

  .xl\\:pr-0px {
    padding-right: 0rem;
  }

  .xl\\:text-18px {
    font-size: 1.125rem;
  }

  .xl\\:text-30px {
    font-size: 1.875rem;
  }

  .xl\\:text-\\[16px\\] {
    font-size: 16px;
  }
}
  
  @media (min-width: 1536px) {

  .\\32xl\\:h-342px {
    height: 21.375rem;
  }

  .\\32xl\\:w-342px {
    width: 21.375rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kEAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;AACA;EACE,8BAA8B;EAC9B;8DACwD;AAC1D;AACA;EACE,0BAA0B;EAC1B;8DACoD;AACtD;AACA;EACE,0BAA0B;EAC1B;8DACoD;AACtD;AACA;EACE,0BAA0B;EAC1B;8DACoD;AACtD;AACA;EACE,0BAA0B;EAC1B;8DACoD;AACtD;AACA;EACE,8BAA8B;EAC9B;8DACwD;AAC1D;AACA;EACE,8BAA8B;EAC9B;8DACwD;AAC1D;AACA;EACE,8BAA8B;EAC9B;8DACwD;AAC1D;AACA;EACE,8BAA8B;EAC9B;8DACwD;AAC1D;AACA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;IAGpB,wBAAwB,GAAG,0BAA0B;IACrD,qBAAqB,GAAG,YAAY;AAHxC;AAKA;IACI,aAAa,GAAG,sBAAsB;AAC1C;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,UAAU;;EAEV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;;EAEzB,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,WAAW;EACb;AACF;AACA;EAQE;;;;GAIC;EACD,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,cAAc;AAChB;AACA,OAAO;AACP;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;;;EAGE,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe,EAAE,gBAAgB;EACjC,aAAa,EAAE,WAAW;EAC1B,uBAAuB;AACzB;AACA,YAAY;AACZ;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA,WAAW;AACX;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,uBAAuB,EAAE,cAAc;EACvC,6BAA6B,EAAE,WAAW;EAC1C,kBAAkB;EAClB,6BAA6B;AAC/B;;;AAGA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB;;EAEA;EACA,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf;;EAEA;EACA,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;EACxB,+BAA+B;EAC/B;;EAvNF;EAAA;AAuNG;;EAvNH;EAAA;AAuNG;;EAvNH;EAAA;AAuNG;;EAvNH;EAAA,kBAuNG;EAvNH;AAuNG;;EAvNH;EAAA,kBAuNG;EAvNH;AAuNG;;EAvNH;EAAA,mBAuNG;EAvNH;AAuNG;;EAvNH;EAAA,mBAuNG;EAvNH;AAuNG;;EAvNH;EAAA;AAuNG;;EAvNH;EAAA,oBAuNG;EAvNH;AAuNG;;EAvNH;EAAA,oBAuNG;EAvNH;AAuNG;;EAvNH;EAAA,oBAuNG;EAvNH;AAuNG;;EAvNH;EAAA,0BAuNG;EAvNH;AAuNG;;EAvNH;EAAA,0BAuNG;EAvNH,oBAuNG;EAvNH;AAuNG;;EAvNH;EAAA,0BAuNG;EAvNH,oBAuNG;EAvNH;AAuNG;;EAvNH;EAAA,iBAuNG;EAvNH;AAuNG;;EAvNH;EAAA;AAuNG;;EAvNH;EAAA;AAuNG;;EAvNH;EAAA;AAuNG;;EAvNH;EAAA,kBAuNG;EAvNH,kBAuNG;EAvNH;AAuNG;;EAvNH;EAAA,kBAuNG;EAvNH;AAuNG;;EAvNH;EAAA,kBAuNG;EAvNH;AAuNG;;EAvNH;EAAA,kBAuNG;EAvNH;AAuNG;;EAvNH;EAAA,kBAuNG;EAvNH;AAuNG;;EAvNH;EAAA,kBAuNG;EAvNH;AAuNG;;EAvNH;EAAA,oBAuNG;EAvNH;AAuNG;;EAvNH;EAAA,oBAuNG;EAvNH;AAuNG;;EAvNH;EAAA,kBAuNG;EAvNH;AAuNG;;EAvNH;EAAA;AAuNG;;EAvNH;EAAA,sBAuNG;EAvNH;AAuNG;;EAvNH;EAAA,8BAuNG;EAvNH;AAuNG;;EAvNH;EAAA,2GAuNG;EAvNH,yGAuNG;EAvNH;AAuNG;;EAvNH;EAAA,oBAuNG;EAvNH;AAuNG;;EAvNH;EAAA;AAuNG;;EAvNH;EAAA;AAuNG;;EAvNH;EAAA;AAuNG;;EAvNH;;EAAA;IAAA;EAuNG;;EAvNH;IAAA,SAuNG;IAvNH;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA,gBAuNG;IAvNH;EAuNG;;EAvNH;IAAA,oBAuNG;IAvNH;EAuNG;;EAvNH;IAAA,gBAuNG;IAvNH;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA,mBAuNG;IAvNH;EAuNG;;EAvNH;IAAA,eAuNG;IAvNH,eAuNG;IAvNH;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA,iBAuNG;IAvNH;EAuNG;;EAvNH;IAAA,sBAuNG;IAvNH;EAuNG;;EAvNH;IAAA,sBAuNG;IAvNH;EAuNG;;EAvNH;IAAA,oBAuNG;IAvNH;EAuNG;;EAvNH;IAAA,oBAuNG;IAvNH;EAuNG;;EAvNH;IAAA,uBAuNG;IAvNH;EAuNG;;EAvNH;IAAA,kBAuNG;IAvNH;EAuNG;;EAvNH;IAAA,kBAuNG;IAvNH;EAuNG;;EAvNH;IAAA,kBAuNG;IAvNH;EAuNG;;EAvNH;IAAA,kBAuNG;IAvNH;EAuNG;;EAvNH;IAAA,kBAuNG;IAvNH;EAuNG;;EAvNH;IAAA,oBAuNG;IAvNH;EAuNG;;EAvNH;IAAA,mBAuNG;IAvNH;EAuNG;;EAvNH;IAAA,iBAuNG;IAvNH;EAuNG;;EAvNH;IAAA,iBAuNG;IAvNH;EAuNG;;EAvNH;IAAA,iBAuNG;IAvNH;EAuNG;;EAvNH;IAAA,gBAuNG;IAvNH;EAuNG;;EAvNH;IAAA,iBAuNG;IAvNH;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA,eAuNG;IAvNH;EAuNG;;EAvNH;IAAA,mBAuNG;IAvNH;EAuNG;;EAvNH;IAAA,kBAuNG;IAvNH;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;AAAA;;EAvNH;;EAAA;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA,sBAuNG;IAvNH;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;AAAA;;EAvNH;;EAAA;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA,kBAuNG;IAvNH;EAuNG;;EAvNH;IAAA,mBAuNG;IAvNH;EAuNG;;EAvNH;IAAA,kBAuNG;IAvNH;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;AAAA;;EAvNH;;EAAA;IAAA,oBAuNG;IAvNH;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA,qBAuNG;IAvNH;EAuNG;;EAvNH;IAAA,mBAuNG;IAvNH;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;AAAA;;EAvNH;;EAAA;IAAA;EAuNG;;EAvNH;IAAA;EAuNG;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n@font-face {\n  font-family: GenSenRoundedTW-M;\n  src: local(\"GenSenRoundedTW-M\"),\n    url(\"./font/GenSenRoundedTW-M.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: GenYoGothic-B;\n  src: local(\"GenYoGothic-B\"),\n    url(\"./font/GenYoGothic-B.ttc\") format(\"truetype\");\n}\n@font-face {\n  font-family: GenYoGothic-H;\n  src: local(\"GenYoGothic-H\"),\n    url(\"./font/GenYoGothic-H.ttc\") format(\"truetype\");\n}\n@font-face {\n  font-family: GenYoGothic-M;\n  src: local(\"GenYoGothic-M\"),\n    url(\"./font/GenYoGothic-M.ttc\") format(\"truetype\");\n}\n@font-face {\n  font-family: DelaGothicOne;\n  src: local(\"DelaGothicOne\"),\n    url(\"./font/DelaGothicOne.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: LINESeedJP_TTF_Bd;\n  src: local(\"LINESeedJP_TTF_Bd\"),\n    url(\"./font/LINESeedJP_TTF_Bd.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: LINESeedJP_TTF_Eb;\n  src: local(\"LINESeedJP_TTF_Eb\"),\n    url(\"./font/LINESeedJP_TTF_Eb.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: LINESeedJP_TTF_Rg;\n  src: local(\"LINESeedJP_TTF_Rg\"),\n    url(\"./font/LINESeedJP_TTF_Rg.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: LINESeedJP_TTF_Th;\n  src: local(\"LINESeedJP_TTF_Th\"),\n    url(\"./font/LINESeedJP_TTF_Th.ttf\") format(\"truetype\");\n}\nhtml {\n  text-size-adjust: none;\n  -webkit-text-size-adjust: none;\n  -ms-text-size-adjust: none;\n  -moz-text-size-adjust: none;\n  font-size-adjust: none;\n}\nhtml {\n    -ms-overflow-style: none;  /* Internet Explorer 10+ */\n    scrollbar-width: none;  /* Firefox */\n}\nhtml::-webkit-scrollbar { \n    display: none;  /* Safari and Chrome */\n}\nbody {\n  font-family: GenSenRoundedTW-M;\n}\n\n.slick-dots {\n  display: flex;\n  justify-content: center;\n  margin: 0;\n  padding: 0.5rem 0;\n  list-style-type: none;\n}\n.slick-dots li {\n  width: 5px;\n  height: 5px;\n  margin: 0 0.2rem;\n}\n.slick-dots li button {\n  display: block;\n  width: 8px;\n  height: 8px;\n  padding: 0;\n\n  border: none;\n  border-radius: 100%;\n  background-color: #c4c4c4;\n\n  text-indent: -9999px;\n}\nli.slick-active button {\n  background-color: #282828;\n}\n@media (max-width: 510px) {\n  .slick-dots {\n    padding: 0.8rem 0;\n  }\n  .slick-dots li button {\n    width: 5px;\n    height: 5px;\n  }\n}\n.c-mask {\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    from(transparent),\n    color-stop(81%, rgba(0, 0, 0, 0.6))\n  );\n  background: linear-gradient(\n    to bottom,\n    transparent 0%,\n    rgba(0, 0, 0, 0.6) 81%\n  );\n  margin-top: auto;\n  padding: 30px 15px 18px;\n  border-radius: 0 0 4px 4px;\n  flex-shrink: 0;\n}\n/* 字體 */\n.font-GenYoGothic-B {\n  font-family: GenYoGothic-B;\n}\n.font-GenYoGothic-H {\n  font-family: GenYoGothic-H;\n}\n.font-GenYoGothic-M {\n  font-family: GenYoGothic-M;\n}\n.font-DelaGothicOne {\n  font-family: DelaGothicOne;\n}\n\n.font-LINESeedJP_TTF_Bd {\n  font-family: LINESeedJP_TTF_Bd;\n}\n.font-LINESeedJP_TTF_Eb {\n  font-family: LINESeedJP_TTF_Eb;\n}\n.font-LINESeedJP_TTF_Rg {\n  font-family: LINESeedJP_TTF_Rg;\n}\n.font-LINESeedJP_TTF_Th {\n  font-family: LINESeedJP_TTF_Th;\n}\ninput[type=\"range\"],\ninput[type=\"range\"]::-webkit-slider-runnable-track,\ninput[type=\"range\"]::-webkit-slider-thumb {\n  -webkit-appearance: none;\n}\ninput[type=\"range\"] {\n  height: 20px;\n  width: 100%;\n  overflow: hidden;\n  border-radius: 10px;\n  cursor: pointer; /* 滑鼠放上會改變鼠標樣式 */\n  outline: none; /* 取消底線效果 */\n  background-color: white;\n}\n/* 滑動軌道 樣式 */\ninput[type=\"range\"]::-webkit-slider-runnable-track {\n  height: 10px;\n  width: 100%;\n  border-radius: 4px;\n  background: #aaa;\n}\n/* 滑動鈕 樣式 */\ninput[type=\"range\"]::-webkit-slider-thumb {\n  position: relative;\n  height: 15px;\n  width: 15px;\n  margin-top: -3px;\n  background-color: white; /* 為了解釋方便所設定 */\n  /* background-color: white; */ /* 我的目標樣式 */\n  border-radius: 50%;\n  /* border: 1px solid black; */\n}\n\n\n.video-player__volume {\n  position: relative;\n  width: 50px;\n  height: 80px;\n  margin-left: 10px;\n  }\n  \n  .video-player__volume-container {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: 60px;\n  background-color: #eee;\n  border-radius: 5px;\n  cursor: pointer;\n  }\n  \n  .video-player__volume-filled {\n  width: 100%;\n  background-color: #333;\n  border-radius: 5px;\n  transform-origin: bottom;\n  transition: transform 0.2s ease;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
